import { CustomInput, CustomTextArea } from "../../../Common/CustomInputs";
import CustomTagInput from "../../../Common/CustomTagInput";
import { Gapper } from "../../../ui/Gapper";
import { SectionHeader, FormRow } from "../practitionerForm.styles";
import { colors } from "../../../../theme/theme";
import * as C from "../practitionerForm.constants";

const ContactInfoSection = ({ submitData, updateField }) => {
  const renderField = (field) => {
    if (field.type === "tag") {
      return (
        <CustomTagInput
          key={field.name}
          hashTags={submitData[field.name]}
          setHashTags={(value) => updateField(field.name, value)}
          color={colors.primary}
          placeholder={field.placeholder}
          label={field.label}
          validation
          validationMsg={C.TAG_VALIDATION_MSG}
        />
      );
    }
    return (
      <CustomInput
        key={field.name}
        value={submitData[field.name]}
        setValue={(value) => updateField(field.name, value)}
        placeholder={field.placeholder}
        label={field.label}
        type={field.inputType || "text"}
        smallBr
        bR="14px"
        width="100%"
        noIcon
        color={colors.primary}
      />
    );
  };

  return (
    <Gapper gap={15}>
      <SectionHeader>Contact Info</SectionHeader>
      <FormRow>
        {C.CONTACT_ROW_FIELDS.map(renderField)}
      </FormRow>
      <CustomTextArea
        placeholder={C.PLACEHOLDER_DESCRIPTION}
        label={C.LABEL_DESCRIPTION}
        value={submitData.desc}
        setValue={(value) => updateField("desc", value)}
        width="100%"
        noIcon
      />
    </Gapper>
  );
};

export default ContactInfoSection;
